import { openIndexedDB } from './openIndexedDB'

export interface RetryImageData {
  fileName: string
  fileType: string
  fileData: ArrayBuffer
}

export async function saveImageToIndexedDB(file: File): Promise<number> {
  const db = await openIndexedDB()
  return new Promise((resolve, reject) => {
    file.arrayBuffer().then(arrayBuffer => {
      const transaction = db.transaction(['images'], 'readwrite')
      const store = transaction.objectStore('images')
      const imageData: RetryImageData = {
        fileName: file.name,
        fileType: file.type,
        fileData: arrayBuffer,
      }

      const request = store.add(imageData)

      request.onsuccess = (event) => {
        resolve((event.target as IDBRequest).result as number)
      }

      request.onerror = (event) => {
        reject(`Erro ao salvar imagem no IndexedDB: ${event}`)
      }
    }).catch(error => {
      reject(`Erro ao converter arquivo para ArrayBuffer: ${error}`)
    })
  })
}
